import React from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Remarkable } from "remarkable";
import { ArrowRight } from "@speedoc/design-assets/build/icons/index.js";
import SectionHeading from "./sectionHeading";
import { LazyLoadImage } from "react-lazy-load-image-component";

const markdown = new Remarkable();

const ContentPreview = ({ content }) => {
  const { title, subtitle, linkText, linkUrl, image, description } = content;
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const mobileStyle = { backgroundImage: `url(${content.backgroundImageMobile})` };

  return (
    <div className="contentPreview" style={mobileStyle}>
      <div className="backgroundImage" />
      <div className="main">
        <div className="left">
          <SectionHeading title={title} subtitle={subtitle} />
          <p className="description" dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
          <Link to={linkUrl} className="buttonLink" arrow="right">
            <span>{linkText}</span> <ArrowRight className="arrow right" />
          </Link>
        </div>
        {!isMobile && (
          <div className="right">
            <LazyLoadImage src={image?.url} alt={image?.alternativeText || ""} effect="blur" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentPreview;
